export default __webpack_public_path__ + "static/media/apple-music.506796d6.svg";